export default __webpack_public_path__ + "static/media/undraw_Organizing_projects_0p9a.7981544a.svg";